const initialState = () => {
  return {
    toasts: [],
  };
};

export default {
  namespaced: true,

  state: () => {
    return initialState();
  },

  mutations: {
    resetState(state) {
      Object.assign(state, initialState());
    },
  },

  actions: {
    add({ state }, data) {
      let hideDelay = 3000;

      if (data.autohide) {
        if (data.delay) hideDelay = data.delay;
      } else {
        hideDelay = false;
      }

      let toastConfig = {
        autohide: hideDelay,
        closeButton: true,
        fade: true,
        position: "bottom-right",
        header: data.title || "title",
        text: data.text || "message",
        color: data.color || undefined,
      };
      state.toasts.push(toastConfig);
    },
  },
};
